export default {
  computed: {
    canManageAgencies() { return this.$store.state.agencies.canManageAgencies === true; },
  },
};
